import React from 'react';
import { useSelector } from 'react-redux';

import {
  adaptStoreToActiveFacetResetHrefs,
  getClearAllFacetsHref,
} from 'src/adapters/storeToPageURL/adaptStoreToUIFacetHrefs';
import { buildListingsURLFromState } from 'src/adapters/storeToPageURL/state/buildListingsURLFromState';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import {
  selectActiveNonTaxonomyFacets,
  selectGuaranteedArrivalDayName,
} from 'src/redux/productsQuery/selectors/selectors';
import { ActiveFacets } from './ActiveFacets';
import { getGuaranteedArrivalChipTitle } from './copy';

export const ActiveFacetsContainer = () => {
  const state = useSelector((state: ReduxApplicationState) => state);
  const allActiveFacets = selectActiveNonTaxonomyFacets(state);
  const activeFacets = adaptStoreToActiveFacetResetHrefs(state, allActiveFacets);
  const clearAllHref = allActiveFacets.length > 0 ? getClearAllFacetsHref(state) : undefined;
  const guaranteedArrivalDayName = selectGuaranteedArrivalDayName(state);
  const conditions = guaranteedArrivalDayName
    ? [
        {
          href: buildListingsURLFromState(state, { guaranteedArrivalDay: null, page: 1 }),
          title: getGuaranteedArrivalChipTitle(guaranteedArrivalDayName),
        },
      ]
    : [];

  return (
    <ActiveFacets activeFacets={activeFacets} clearAllHref={clearAllHref} conditions={conditions} />
  );
};
